import { ROUTE } from 'utils/constants';

const config = {
  PATH: ROUTE.ASSISTED,
  ID: 'ASSISTED',
  SIDEBAR_IMAGE: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_CONTINUE: false,
  FOOTER: false,
};

export default config;
